import { render } from "./DocumentPoste.vue?vue&type=template&id=4b239c20&scoped=true&ts=true"
import script from "./DocumentPoste.vue?vue&type=script&lang=ts"
export * from "./DocumentPoste.vue?vue&type=script&lang=ts"

import "./DocumentPoste.vue?vue&type=style&index=0&id=4b239c20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b239c20"]])

export default __exports__